import { WintSuperkollAPIModel, WintUtilsWebApi } from "wint-api-client/dist/types";

/** Dimensions Client **/
export const CompatibleDimensions = [
  WintSuperkollAPIModel.DimensionCompatibilityType.CostCenter,
  WintSuperkollAPIModel.DimensionCompatibilityType.Project,
];

export const DefaultFilter: WintUtilsWebApi.Filter = {
  page: 0,
  orderByProperty: "",
  orderByDescending: true,
  thenByDescending: false,
  isAutoPaginating: true,
  includeSummary: false,
};

export const SuggestionsCount = 5;

export const CLIENT_CAPABILITIES_HEADER = "X-Wint-Capabilities";
// The onboarding session JWT rides on its own header, never on Authorization:
// Superkoll's reverse proxy strips inbound Authorization and replaces it with an
// AAD bearer for the service hop, so a token sent there never reaches Onboarding.
export const ONBOARDING_SESSION_HEADER = "X-Onboarding-Session";
// The InviteToken is a credential, so it travels as a header rather than in the
// path or query where it would land in Referer headers, proxy logs and request
// telemetry. Core requires it on both the begin call and every status poll.
export const INVITE_TOKEN_HEADER = "X-Invite-Token";
// The offboarding material's link token and session, the same way as onboarding's two above.
export const OFFBOARDING_LINK_HEADER = "X-Offboarding-Link";
export const OFFBOARDING_SESSION_HEADER = "X-Offboarding-Session";
export const CLIENT_CAPABILITIES = [
  "ReceiptPaymentMethodNullability",
  "TimeReportingSelfBilling",
  "TimeReportingSelfBillingRateFromDate",
].join(",");
